const ToastPopup = {
    success: (message) => {
      window.showToast(message, 'success');
    },
    error: (message) => {
      window.showToast(message, 'error');
    },
  };
  
  export default ToastPopup;
  